import React from 'react';
import { connect } from 'react-redux'

import { Row, Col, Divider, List, Spin, Empty } from 'antd';
import InfiniteScroll from 'react-infinite-scroll-component';
import { _fmtRupiah } from '../../../../../lib/Helper';

class Mobile extends React.Component {
  componentDidMount() {
    this.props.fetchTable(true)
  }

  render() {
    const { table } = this.props.state

    return (
      <>
        <Row gutter={[16, 16]}>
          <Col xs={24}>
            <InfiniteScroll
              dataLength={table.data.length}
              next={this.props.fetchTable}
              hasMore={table.pagination.total != null && table.data.length < table.pagination.total}
              loader={<div style={{ textAlign: "center" }}><Spin size="small" /></div>}
              endMessage={
                table.loading_first ? "" : (table.data.length ? <Divider /> : <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="Data tidak ditemukan" />)
              }
            >
              <List
                loading={table.loading_first}
                locale={{ emptyText: " " }}
                dataSource={table.data}
                renderItem={(row, i) => (
                  <List.Item
                    key={i}
                  >
                    <List.Item.Meta
                      title={row.siswa_nama}
                      description={<>
                        <Row gutter={[8, 8]}>
                          <Col xs={24}>
                            <small>
                              <b>Tahun Ajaran:</b> {row.tahun_ajaran ? row.tahun_ajaran : "-"} <br />
                              <b>Biaya:</b> {row.tagihan_nama ? row.tagihan_nama : "-"} <br />
                              <b>Total Tagihan:</b> {"Rp. " + (row.total_tagihan ? _fmtRupiah(row.total_tagihan) : 0)} <br />
                              <b>Biaya Opsional:</b> {"Rp. " + (row.total_biaya_opsional ? _fmtRupiah(row.total_biaya_opsional) : 0)} <br />
                              <b>Total Pembayaran:</b> {"Rp. " + (row.total_pembayaran ? _fmtRupiah(row.total_pembayaran) : 0)} <br />
                              <b>Belum Dibayar:</b> {"Rp. " + (row.total_belum_dibayar ? _fmtRupiah(row.total_belum_dibayar) : 0)} <br />
                            </small>
                          </Col>
                        </Row>
                      </>}
                    />
                  </List.Item>
                )}
              />
            </InfiniteScroll>
          </Col>
        </Row>
      </>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    privilege: state.privilege,
  }
}

export default connect(mapStateToProps)(Mobile);
